var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVenngageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2896 0C7.27834 0 0 7.27834 0 16.2896C0 25.3009 7.27834 32.5792 16.2896 32.5792C25.3009 32.5792 32.5792 25.3009 32.5792 16.2896C32.5792 7.34766 25.3009 0.0693175 16.2896 0ZM16.2896 2.0102C18.6464 2.0102 21.0032 2.63406 23.0827 3.74314L16.2203 10.6056L9.14991 3.95109C11.3681 2.63405 13.7942 2.0102 16.2896 2.0102ZM16.2896 30.569C8.38742 30.569 2.01021 24.1918 2.01021 16.2896C2.01021 11.9226 4.02041 7.76355 7.48629 5.06017L14.8339 11.9919L16.2896 13.4476L24.885 4.85223C31.1929 9.56582 32.5099 18.5078 27.7963 24.8157C25.0929 28.4895 20.7953 30.569 16.2896 30.569Z",
    fill: "#2B2B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenngageIcon);
export default __webpack_public_path__ + "static/media/venngage-icon.3c3b0ff0b302f9f011ef9accc43b46d3.svg";
export { ForwardRef as ReactComponent };